export interface RangeSliderProps {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  label?: string;
  leftLabel?: string;
  centerLabel?: string;
  rightLabel?: string;
  'data-testid'?: string;
}

/**
 * Labeled range slider (reference: Creativity / Temperature).
 */
export function RangeSlider({
  value,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  label,
  leftLabel = 'Precise',
  centerLabel = 'Balanced',
  rightLabel = 'Creative',
  'data-testid': dataTestId,
}: RangeSliderProps) {
  const percent = max > min ? ((value - min) / (max - min)) * 100 : 0;

  return (
    <div data-testid={dataTestId ?? 'design-system-range-slider'}>
      {label ? <p className="mb-3 text-sm font-medium text-primary">{label}</p> : null}
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        className="h-2 w-full cursor-pointer appearance-none rounded-full bg-subtle accent-success"
        style={{
          background: `linear-gradient(to right, var(--kc-success) 0%, var(--kc-success) ${percent}%, var(--kc-bg-subtle) ${percent}%, var(--kc-bg-subtle) 100%)`,
        }}
      />
      <div className="mt-2 flex justify-between text-xs text-muted">
        <span>{leftLabel}</span>
        <span>{centerLabel}</span>
        <span>{rightLabel}</span>
      </div>
    </div>
  );
}
